import React from 'react';
import styled from 'styled-components';
import { tokens } from '@utmost.co/utmost-design-system';

const FormPage: React.FC<React.PropsWithChildren> = ({ children }) => (
  <StyledContainer>
    <StyledContent>{children}</StyledContent>
  </StyledContainer>
);

export default FormPage;

const StyledContainer = styled.div`
  background-color: ${tokens.colorSurface};
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
`;

const StyledContent = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 70px auto 20px auto;
`;
